
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKUSplittingLaborGrid extends Serenity.EntityGrid<SKUSplittingLaborRow, any> {
        protected getColumnsKey() { return 'Inventory.SKUSplittingLabor'; } 
        protected getIdProperty() { return SKUSplittingLaborRow.idProperty; }
        protected getInsertPermission() { return SKUSplittingLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return SKUSplittingLaborRow.localTextPrefix; }
        protected getService() { return SKUSplittingLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}